/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon24Solid = forwardRef('ArrowAUpLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16 3a1.5 1.5 0 0 1 0 3H8.121l11.94 11.94a1.5 1.5 0 0 1-2.122 2.12L6 8.122V16a1.5 1.5 0 0 1-3 0V6.5A3.5 3.5 0 0 1 6.5 3H16Z" })));
});
